import { jsx, Fragment } from "react/jsx-runtime";
import { memo, createElement } from "react";
import { useTranslation } from "react-i18next";
const Translate = memo(
  ({ component = "span", className, children, options, fallback, dangerous, ...props }) => {
    const { t } = useTranslation();
    if (typeof children === "undefined")
      return null;
    if (typeof children !== "string")
      return /* @__PURE__ */ jsx(Fragment, { children });
    if (dangerous) {
      return createElement(component, {
        className,
        "data-translation-key": children,
        dangerouslySetInnerHTML: {
          __html: t(children, {
            ...options,
            ...props,
            defaultValue: fallback
          })
        }
      });
    }
    return createElement(
      component,
      {
        className,
        "data-translation-key": children
      },
      /* @__PURE__ */ jsx(Fragment, { children: t(children, {
        ...options,
        ...props,
        defaultValue: fallback
      }) })
    );
  }
);
export {
  Translate
};
